import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { loadShadows, selectShadow } from 'components/shadow_grid/shadows/store/shadows/actions';

import Editor from './editor';
import Header from 'components/shadow_grid/shadows/header';
import LoadingSpinner from 'components/ui/loading_spinner';
import Table from 'components/shadow_grid/shadows/table';

import './styles.scss';

export function ShadowsPage({
  loaded,
  loadShadows,
  selectedShadow,
  selectedGlobalShadow,
  selectGlobalShadow,
  selectShadow,
  setDirty
}) {
  React.useEffect(() => {
    if (!loaded && !selectedShadow) {
      loadShadows();
    }
  }, [loaded, selectedShadow]);

  React.useEffect(() => {
    if (selectedGlobalShadow === null) {
      selectShadow(null);
    }
  }, [selectedGlobalShadow]);

  let content;
  if (selectedShadow) {
    // TODO: This generic shadows index shouldn't know about an external setDirty
    //       At least rename the callback to something like onEditEnd and call it in useEffect above
    //       Or better yet, inject it into the actions/store somehow so the selectShadow(null) action can call it and
    //       these components can all stay dumb
    content = <Editor selectGlobalShadow={selectGlobalShadow} setDirty={setDirty} />;
  } else if (loaded) {
    content = [
      <Header key="header" />,
      <Table key="table" selectGlobalShadow={selectGlobalShadow} />
    ];
  } else {
    content = <LoadingSpinner />;
  }

  return (
    <div className="shadows-index d-flex flex-column">
      {content}
    </div>
  );
}

ShadowsPage.propTypes = {
  loaded: PropTypes.bool,
  loadShadows: PropTypes.func.isRequired,
  selectedGlobalShadow: PropTypes.object,
  selectedShadow: PropTypes.object,
  selectGlobalShadow: PropTypes.func,
  selectShadow: PropTypes.func.isRequired,
  setDirty: PropTypes.func,
};

const mapStateToProps = state => ({
  loaded: state.shadows.loaded,
  selectedShadow: state.shadows.selected,
});

const mapDispatchToProps = {
  loadShadows,
  selectShadow,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShadowsPage);
